import { useEffect } from 'react';
import { useConfig, usePusher } from '@marvelapp/ballpark-application';
import { PusherEvent } from '@marvelapp/core';
export function useTranscriptionPusher({ projectPk, resultPk, refetch, }) {
    const config = useConfig();
    const { pusher } = usePusher();
    useEffect(() => {
        if (!projectPk || !resultPk)
            return;
        const channelName = `${config.pusher.projectChannelPrefix}${projectPk}`;
        const { bindChannel } = pusher.subscribe(channelName);
        const handleTranscriptionProcessed = (eventData) => {
            if (eventData.content.result_pk === resultPk &&
                eventData.content.status === 'SUCCESS') {
                refetch();
            }
        };
        const unbindTranscriptionProcessed = bindChannel(PusherEvent.TranscriptionProcessed, handleTranscriptionProcessed);
        return () => {
            unbindTranscriptionProcessed();
        };
    }, [
        config.pusher.projectChannelPrefix,
        pusher,
        projectPk,
        refetch,
        resultPk,
    ]);
}
